import { render } from "./Pallets.vue?vue&type=template&id=51432e48"
import script from "./Pallets.vue?vue&type=script&lang=ts"
export * from "./Pallets.vue?vue&type=script&lang=ts"
script.render = render

export default script